import { NavLink, useLocation } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';

export const PUBLIC_NAV = [
  { to: paths.welcome, key: 'nav.home', end: true },
  { to: paths.companyPlans, key: 'nav.companyPlans' },
  { to: paths.terms, key: 'nav.terms' },
  { to: paths.privacy, key: 'nav.privacy' },
];

export function isActivePath(pathname, item) {
  if (item.end) {
    return pathname === item.to || (item.to === paths.welcome && pathname === paths.root);
  }
  return pathname === item.to || (item.match && pathname.startsWith(item.match));
}

export function PublicNavLinks({ id, className, onNavigate }) {
  const { t } = useI18n();
  const location = useLocation();
  return (
    <nav id={id} className={className} aria-label={t('layout.publicNavigation')}>
      {PUBLIC_NAV.map((item) => {
        const current = isActivePath(location.pathname, item);
        return (
          <NavLink
            key={item.to}
            to={item.to}
            aria-current={current ? 'page' : undefined}
            className={current ? 'active' : undefined}
            onClick={onNavigate}
          >
            {t(item.key)}
          </NavLink>
        );
      })}
    </nav>
  );
}
